import { getBezierPath, type ConnectionLineComponentProps } from '@xyflow/react';

export function ConnectionLine({
  fromX,
  fromY,
  toX,
  toY,
  fromPosition,
  toPosition,
}: ConnectionLineComponentProps) {
  const [path] = getBezierPath({
    sourceX: fromX,
    sourceY: fromY,
    sourcePosition: fromPosition,
    targetX: toX,
    targetY: toY,
    targetPosition: toPosition,
  });

  return (
    <g className="app-connection-line">
      <path d={path} fill="none" strokeDasharray="6 4" strokeWidth={2} />
      <circle cx={toX} cy={toY} r={4} strokeWidth={2} />
    </g>
  );
}
